import { Pipe, PipeTransform } from '@angular/core';
import { SiteModule } from '../site-modules';

@Pipe({ name: 'onlyVisibleModules' })
export class OnlyVisibleModulesPipe implements PipeTransform {
  transform(modules: SiteModule[]): SiteModule[] {
    return modules.filter(module => !module.isHidden);
  }
}
